import {
  CreateMarketplaceUserRequest,
  MarketplaceUser,
  MarketplaceUserRole,
  UpdateMarketplaceUserRequest,
} from 'APIs/marketplace.users/marketplace.users.types';

export const defaultUserRole = 'support' as MarketplaceUserRole;

export type UserFormProps = {
  userId: string | null;
  firstName: string;
  lastName: string;
  email: string;
  role: MarketplaceUserRole | '';
  enabled: boolean;
};

type ToCreateMarketplaceUserRequest = (userForm: UserFormProps) => CreateMarketplaceUserRequest;
type ToUpdateMarketplaceUserRequest = (userForm: UserFormProps) => UpdateMarketplaceUserRequest;
type ToUserFormProps = (user: MarketplaceUser) => UserFormProps;

export const toCreateMarketplaceUserRequest: ToCreateMarketplaceUserRequest = (
  userForm: UserFormProps,
): CreateMarketplaceUserRequest => {
  return {
    firstName: userForm.firstName,
    lastName: userForm.lastName,
    emailAddress: userForm.email,
    userRole: userForm.role ? userForm.role : defaultUserRole,
  };
};

export const toUpdateMarketplaceUserRequest: ToUpdateMarketplaceUserRequest = (
  userForm: UserFormProps,
): UpdateMarketplaceUserRequest => {
  return {
    userRole: userForm.role ? userForm.role : defaultUserRole,
    status: userForm.enabled ? 'Enabled' : 'Disabled',
  };
};

export const toUserFormProps: ToUserFormProps = (user: MarketplaceUser): UserFormProps => {
  return {
    userId: user._id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.emailAddress,
    role: user.userRole,
    enabled: user.status === 'Enabled',
  };
};
